import React, { useEffect, useState } from 'react';
import { get, isEmpty, isArray } from 'lodash';
import PropTypes from 'prop-types';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  liveDoubtClassList,
  liveDoubtClassDetail
} from '../../../../actions/liveDoubtClassAction';
import { dateFormat } from '../../../../api/dateFormat';
// Material Imports
import { Grid, Button } from '@material-ui/core';
// Components
import TimerCard from '../../../../components/TimerCard.js';
import LoadingSkeleton from '../../../../components/LoadingSkeleton';
import { Link } from 'react-router-dom';
import PageHeading from '../../../../components/PageHeading';
import NoData from '../../../../components/NoData';
import ScrollToTop from '../../../../components/ScrollToTop';
import { openSnackBar } from '../../../../actions/snackbarAction';

const LiveWebinarLayout = props => {
  // State
  const [isDigitalClassFetching, setIsDigitalClassFetching] = useState(false);
  const loginData = useSelector(state =>
    get(state, 'loginReducer.data.jwt', {})
  );
  // Redux
  const dispatch = useDispatch();
  const liveWebinarListData = useSelector(state =>
    get(state, 'liveDoubtClassReducer.data', {})
  );
  const errorMessage = useSelector(state =>
    get(state, 'liveDoubtClassReducer.errorMessage', '')
  );

  // Functions
  useEffect(() => {
    setIsDigitalClassFetching(true);
    liveDoubtClassList(loginData, dispatch).then(() => {
      setIsDigitalClassFetching(false);
    });
  }, []);

  const onRefresh = React.useCallback(() => {
    setIsDigitalClassFetching(true);
    liveDoubtClassList(loginData, dispatch).then(() => {
      populatedigitalClassList();
      setIsDigitalClassFetching(false);
    });
  });

  const populatedigitalClassList = () => {
    let list = [];
    var i = 0;
    if (!isEmpty(liveWebinarListData.liveSchedule))
      (isArray(liveWebinarListData.liveSchedule)
        ? liveWebinarListData.liveSchedule
        : []
      ).map((data, index) => {
        let classList = [];
        data.listClass.map((classes, classIndex) => {
          let uniquekey = `${index}${classIndex}`;
          if (!(props.totalCard && i >= props.totalCard))
            classList.push(
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                key={uniquekey}
                className="flex"
              >
                {classes.RemainingTime < 0 ? (
                  <Link
                    to={'/live-doubt-class/' + classes.UniqueCode}
                    className="timer-card-container"
                  >
                    <ScrollToTop />
                    <TimerCard
                      index={uniquekey}
                      key={uniquekey}
                      subject={classes.SubjectName}
                      dateTime={`${dateFormat(data.ClassDate)} at ${
                        classes.ClassStart
                      }`}
                      topic={classes.ModuleNo}
                      start={'EXPIRE IN'}
                      initialTime={classes.Expiry * 1000}
                      callback={onRefresh}
                      handler={() => {
                        liveDoubtClassDetail(
                          loginData,
                          classes.UniqueCode,
                          dispatch
                        ).then(data => {
                          window.open(data.data.ClassURL, '_self');
                        });
                      }}
                    />
                  </Link>
                ) : (
                  <TimerCard
                    index={uniquekey}
                    key={uniquekey}
                    subject={classes.SubjectName}
                    dateTime={`${dateFormat(data.ClassDate)} at ${
                      classes.ClassStart
                    }`}
                    topic={classes.ModuleNo}
                    handler={() => {
                      dispatch(
                        openSnackBar({
                          message:
                            'Your Scheduled class is yet to start, please wait',
                          severity: 'warning'
                        })
                      );
                    }}
                    start={'START IN'}
                    initialTime={classes.RemainingTime * 1000}
                    callback={onRefresh}
                  />
                )}
              </Grid>
            );
          i = i + 1;
        });
        return list.push(
          <React.Fragment key={index}>{classList}</React.Fragment>
        );
      });

    return list;
  };

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={true}>
          <PageHeading titlePrimary="Live" titleSecondary="Doubt Class" />
        </Grid>
        {!isDigitalClassFetching && liveWebinarListData.IsDoubtSlot ? (
          <Grid item xs="auto">
            <Button
              variant="contained"
              color="secondary"
              onClick={() =>
                window.open(liveWebinarListData.DoubtSlotURL, '_self')
              }
            >
              Book Live Doubt Slot
            </Button>
          </Grid>
        ) : null}
      </Grid>
      {isDigitalClassFetching ? (
        <LoadingSkeleton type="bigcardlist" />
      ) : (
        <Grid container spacing={2}>
          {!isEmpty(populatedigitalClassList()) ? (
            populatedigitalClassList()
          ) : (
            <NoData
              message={
                !isEmpty(errorMessage) ? errorMessage : 'No data Available'
              }
            />
          )}
        </Grid>
      )}
    </React.Fragment>
  );
};

export default LiveWebinarLayout;

LiveWebinarLayout.propTypes = {
  heading: PropTypes.bool,
  totalCard: PropTypes.number
};

LiveWebinarLayout.defaultProps = {
  heading: true
};
